import React from 'react';
import bemHelper from 'react-bem-helper';

import './styles.scss';
import Comment from '../Comment/Comment';
import { isDesktop } from '../../utils';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-comments' });

class CommentsModule extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDesktop: true
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      isDesktop: isDesktop()
    });
  }

  render() {
    const { comments, hasWrap, gridWrap } = this.props;
    const isFull = (hasWrap || comments.length > 2) && this.state.isDesktop;
    const isSingle = !hasWrap && comments.length === 1;
    const classes = {
      full: isFull,
      'not-full': !isFull,
      alone: isSingle,
    };

    return (
      <section {...bem()}>
        <h2 {...bem('title', classes)}>Press Comments</h2>
        <div {...bem('wrapper')}>
          <div {...bem('list', classes, 'comments')} style={ { minHeight: this.state.internalHeight } } ref="list">
            {
              comments.map((comment, index) => {
                return (
                  <Comment isFull={isFull}
                           hasWrap={hasWrap}
                           isSingle={isSingle}
                           gridWrap={gridWrap}
                           comment={comment}
                           key={index}/>
                );
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default CommentsModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/CommentsModule/CommentsModule.js